

export const EventStruct = {
        id: '',
        // date: '',
        etag: '',
        description: '',
        summary: '',
        status: '',
        type: '', //colorId ... 'is-link', 'is-info', 'is-warning', 'is-success', 'is-danger'
        creator: {
            id: '',
            email: '',
            displayName: '',
            // "self": true
        },
        attendees: [
            // {
            //   id: '',
            //   email: '',
            //   displayName: '',
            //   organizer: false,
            //   //"self": false,
            //   //"resource": false,
            //   //"optional": false,
            //   //"responseStatus": '',
            //   //"comment": '',
            //   //"additionalGuests": 0
            // }
        ],
        start: {
            date: '',
            dateTime: '',
            timeZone: ''
        },
        end: {
            date: '',
            dateTime: '',
            timeZone: ''
        },
  }

  export const MemberStruct = 
    { 
      id: '', 
      firstname: '', 
      name: 'NewUser', 
      title: '', 
      email: '', 
      phone: '', 
      role: 'USER', 
      username: 'NewUser',
      password: '',
      description: '',
      gravatar: '', 
      pic: ''  ,
      active: true,
      initialpwd: '',
      accountid: ''
  }

export const PurchaseStruct =  
{   
    id: '',
    pdate: '',
    amount: 10, 
    item: '', 
    comment: '',
    contactid: '',
    userid: '',
    userdisplayname: ''
}

// ActivityTypes ; 'MSG_IN', 'MSG_OUT', 'REMINDER'
// ActivityStatus : 'DONE', 'OPEN', 'INCOMPLETE'

export const ActivityStruct =  
{
    id: '', 
    due: {
        date: '',
        dateTime: ''
    },   
    createdate: '', 
    sent: true, 
    channel: '', 
    header: '',
    message: '', 
    contacts: [
        // {id: '1', displayName: 'Aanet Perkins'}, 
    ],
    groups: [
        // '' //.. just nametags
    ], //tag OR custclass OR none 
    type: '',  
    status: '',
    done: false,
    eventid: ''
}

export const ChannelStruct = 
{
    id: '',
    type: '',
    displayName: '',
    class: ''
}

